import React from 'react'
import {pathOr} from 'ramda'
import {SearchFilterForm} from '@modifi/ui'

import Filter, {CommonFilterProps, FilterOption} from '../../ui/filter'
import SpontanSearchFilterForm from '../search-filter-form'

export type SearchFilterProps = CommonFilterProps & {
  // not needed by the spontaneous search, which filters on the already fetched search object
  search?: (searchString: string) => Promise<FilterOption[]>
  filterKey?: string
  minLength?: number
  isSpontanSearch?: boolean
}

const SearchFilter: React.FC<SearchFilterProps> = ({
  search = undefined,
  filterKey = 'filter.externalId',
  isSpontanSearch = false,
  minLength = 3,
  ...restFilterProps
}) => {
  const handleSearch = (searchString: string) => {
    if (!search || searchString.length < minLength) {
      return new Promise(resolve => resolve([]))
    }
    return search(searchString)
  }

  const getSearchParams = (selected: FilterOption[] | string) => {
    if (!Array.isArray(selected)) {
      return {[filterKey]: selected}
    }
    return {
      [filterKey]: selected.map(({value, label}) => `${value}:${label}`),
    }
  }

  const getDefaultParams = (searchObj: Record<string, any>) => {
    if (isSpontanSearch) return pathOr([], [filterKey], searchObj)
    return {
      defaultSelected: pathOr<string[]>([], [filterKey], searchObj).map(optionString => {
        const [value, ...label] = optionString.split(':')
        return {label: label.join(':'), value}
      }),
    }
  }

  return (
    <Filter
      filterComponent={!isSpontanSearch ? SearchFilterForm : SpontanSearchFilterForm}
      getSearchParams={getSearchParams}
      getDefaultParams={getDefaultParams}
      onSearch={handleSearch}
      minLength={minLength}
      {...restFilterProps}
    />
  )
}

export default SearchFilter
